/**
 * Domain-input helpers for the super-admin org forms.
 *
 * The domains textarea accepts one hostname per line (commas also tolerated).
 * The backend is the source of truth for normalization + the one-host-one-org
 * rule; these helpers mirror the backend's `normalize_host` so the value the user
 * sees (and the dedupe) matches what the backend will store — e.g. a pasted
 * `https://Portal.Example.com/` becomes `portal.example.com`.
 */

// Reduce a raw host/URL to a bare comparable hostname (mirror of backend normalize_host):
// lowercase; strip scheme, userinfo, path, port, and any trailing dot.
export const normalizeHost = (raw) => {
  if (!raw) return '';
  let h = raw.trim().toLowerCase();
  const scheme = h.indexOf('://');
  if (scheme !== -1) h = h.slice(scheme + 3); // everything after the first "://"
  h = h.split('/', 1)[0];              // drop path
  if (h.includes('@')) h = h.slice(h.lastIndexOf('@') + 1); // drop userinfo
  h = h.split(':', 1)[0];              // drop port
  return h.replace(/\.+$/, '');        // drop trailing dot(s)
};

// Free-text (newline/comma separated) -> normalized, deduped hostname array.
export const parseDomains = (text) => {
  if (!text) return [];
  const out = [];
  for (const raw of text.split(/[\n,]/)) {
    const host = normalizeHost(raw);
    if (host && !out.includes(host)) out.push(host);
  }
  return out;
};

// Array -> textarea value (one host per line).
export const domainsToText = (domains) => (domains || []).join('\n');
